import React, { useEffect } from 'react';
import Product from '../components/Product';
import { products } from '../data';

const Checkout = () => {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
    return (
        <div className="w-full h-fit py-12">
            <div className="mxw">
                <div className="w-full flex items-center justify-center pb-10">
                    <h2 className="text-lg md:text-xl lg:text-2xl font-medium">Checkout</h2>
                </div>
                <section className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12">
                    {/* form */}
                    <div>
                        <p className="text-lg md:text-xl pb-10">Delivery Options</p>
                        <form className="w-full space-y-4">
                            <div className="flex items-center gap-4 justify-between pb-4 md:pb-8">
                                <button disabled className="w-full py-3 px-4 rounded-lg border border-black flex items-center justify-center space-x-3">
                                    <span>Ship</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                                    </svg>
                                </button>
                                <button disabled className="w-full py-3 px-4 rounded-lg border border-gray-200 flex items-center justify-center space-x-3">
                                    <span>Pickup</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                    </svg>
                                </button>
                            </div>
                            <div className="flex items-center justify-between gap-4">
                                <input type="text" placeholder="First Name*" className="w-full py-3 px-2 border border-gray-500 rounded-lg" />
                                <input type="text" placeholder="Last Name*" className="w-full py-3 px-2 border border-gray-500 rounded-lg" />
                            </div>
                            <div className="pb-4 md:pb-8">
                                <input type="text" placeholder="Address*" className="w-full py-3 px-2 border border-gray-500 rounded-lg" />
                            </div>
                            <div className="flex items-center justify-between gap-4">
                                <input type="text" placeholder="Email*" className="w-full py-3 px-2 border border-gray-500 rounded-lg" />
                                <input type="text" placeholder="Phone*" className="w-full py-3 px-2 border border-gray-500 rounded-lg" />
                            </div>
                            <div className="flex items-center justify-end">
                                <button className="py-3 px-4 bg-gray-200 text-gray-500 rounded-full font-medium" disabled>Save &amp; Continue</button>
                            </div>
                        </form>
                    </div>
                    {/* details */}
                    <div className="text-gray-700">
                        <div className="flex items-center justify-between text-md md:text-lg">
                            <p className="font-medium">Subtotal:</p>
                            <p>$160</p>
                        </div>
                        <div className="flex items-center justify-between text-md md:text-lg">
                            <p className="font-medium">Estimated Shipping:</p>
                            <p><span className="line-through">$8.00</span> <span>Free</span></p>
                        </div>
                        <div className="flex items-center justify-between text-md md:text-lg pb-2">
                            <p className="font-medium">Estimated Tax:</p>
                            <p>$13</p>
                        </div>
                        <div className="flex items-center justify-between text-md md:text-lg pb-6">
                            <p className="font-bold text-black">Total:</p>
                            <p className="font-bold text-black">$173</p>
                        </div>
                        <div>
                            <p className="font-bold">Arrived Wed, Oct 19</p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 pt-4">
                            {products?.slice(12,14)?.map(product => (
                                <div className="w-full md:max-w-xs">
                                    <Product product={product} />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Checkout;
